import React, { useState } from 'react';
import FadeInSection from './FadeInSection';
import ContactFormModal from './ContactFormModal';
import { useTranslation } from '../i18n/useTranslation';
import { trackContactClick } from '../track';

const DemoCTASection = ({ colorScheme = 'darkBlue' }) => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const bgColor = colorScheme === 'purple'
    ? 'bg-gradient-to-br from-purple-300 via-purple-400 to-purple-500'
    : colorScheme === 'purpleDark'
    ? 'bg-gradient-to-br from-purple-600 to-purple-700'
    : colorScheme === 'blue'
    ? 'bg-gradient-to-br from-blue-300 via-blue-400 to-blue-500'
    : colorScheme === 'orange'
    ? 'bg-gradient-to-br from-orange-500 to-orange-600'
    : 'bg-brand-dark-blue';

  return (
    <section
      className={`relative py-12 ${bgColor} overflow-hidden`}
      style={{ marginTop: '-1px', marginBottom: '-1px' }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <FadeInSection animation="fade-in-up" threshold={0.2}>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* Text Content */}
            <div className="text-white text-center lg:text-left">
              <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold leading-tight">
                {t('demoCTA.title')}{' '}
                <span className="inline-block">{t('demoCTA.titleHighlight')}</span>
              </h2>
            </div>

            {/* CTA Button */}
            <div className="flex-shrink-0">
              <button
                onClick={() => {
                  trackContactClick('demo-cta');
                  setIsContactModalOpen(true);
                }}
                className={`inline-block bg-white text-blue-500 hover:bg-gray-100 font-bold text-base uppercase tracking-wider rounded-full px-8 py-3 transition-all duration-300 transform hover:scale-105 hover:shadow-xl`}
              >
                {t('demoCTA.ctaButton')}
              </button>
            </div>
          </div>
        </FadeInSection>
      </div>

      {/* Contact Form Modal */}
      <ContactFormModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
    </section>
  );
};

export default DemoCTASection;